import { render } from "./DAOPage.vue?vue&type=template&id=3135c85a"
import script from "./DAOPage.vue?vue&type=script&lang=js"
export * from "./DAOPage.vue?vue&type=script&lang=js"

import "./DAOPage.vue?vue&type=style&index=0&id=3135c85a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__